export enum NumberFormatType {
	None = 'none',
	CommaSeparated = 'comma',
	Compact = 'compact',
	Percent = 'percent',
	Custom = 'custom',
}

export type Delimiter = 'comma' | 'dot' | 'space';

export type UnitPosition = 'before' | 'after';

export type NumberFormatConfig =
	| {
			type: NumberFormatType.None;
	  }
	| {
			type: NumberFormatType.CommaSeparated;
	  }
	| {
			type: NumberFormatType.Compact;
	  }
	| {
			type: NumberFormatType.Percent;
	  }
	| {
			type: NumberFormatType.Custom;
			delimiter: Delimiter;
			unit: string;
			unitPosition: UnitPosition;
			precision: string;
			compact: boolean;
	  };
